__turbopack_context__.v({
  "iconSettings": "IconSettings-module-scss-module__gJG1rG__iconSettings",
});
